export default __webpack_public_path__ + "static/media/ic_settings_tray.dd5301df.png";